import React from 'react'
import { MINI_DRAWER } from 'constants/ActionTypes'
import Logo from 'assets/images/logo.jpg'

const SidenavLogo = ({drawerType}) => {
  const showMini = drawerType.includes(MINI_DRAWER)

  return (
    <div className='sidebar-header d-flex align-items-center'>
      {showMini
        ? <div className='mini-logo'>
          <img className='mini-logo-img' alt='...' src='http://via.placeholder.com/32x32' />
          <img className='mini-logo-img-hover' alt='...' src='http://via.placeholder.com/105x36' />
        </div> : <div className='d-flex align-items-center'>
          <img alt='...' src={Logo} width='20%' />
          <span className='h3 pl-2 mb-0'>Majocchi Gestione Listino</span>
        </div>
      }
    </div>
  )
}

export default SidenavLogo



// WEBPACK FOOTER //
// ./components/SidenavLogo/index.js